/**
 * OncoAgent analytics hooks (placeholders).
 * Uses GA4 (window.gtag) when available; mirrors @/utils/seo/analytics.
 */

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || '';

export function trackOncoAgentPageView(pagePath: string, pageTitle: string): void {
  if (typeof window !== 'undefined' && window.gtag && GA_ID) {
    window.gtag('config', GA_ID, { page_path: pagePath, page_title: pageTitle });
  }
}

export function trackOncoAgentCTA(
  ctaType: string,
  location: string,
  data?: Record<string, unknown>
): void {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', `cta_click_${ctaType}`, {
      event_category: 'OncoAgent',
      event_label: location,
      page_path: window.location.pathname,
      ...data,
    });
  }
}

export function trackOncoAgentConversion(
  conversionType: string,
  value?: number | string | null
): void {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', `conversion_${conversionType}`, {
      value: value ?? undefined,
      event_category: 'OncoAgent',
    });
  }
}
